export default __webpack_public_path__ + "static/media/user.a16f627d.svg";